import { Container } from 'unstated'
import * as Cookies from 'js-cookie'

export const getLocation = (paramName) => {
  let currentSearchInfo = Cookies.get('currentSearch')
    ? JSON.parse(Cookies.get('currentSearch'))
    : null

  if (!currentSearchInfo) {
    return null
  }

  if (paramName === 'location') {
    return currentSearchInfo.location
  }

  if (paramName === 'lat') {
    return currentSearchInfo.lat
  }

  if (paramName === 'lng') {
    return currentSearchInfo.lng
  }
}

class SearchContainer extends Container {
  state = {
    location: getLocation('location'),
    lat: getLocation('lat'),
    lng: getLocation('lng'),
  }

  updateLocation = (locationInformation) => {
    Cookies.set('currentSearch', JSON.stringify(locationInformation))

    this.setState({
      location: locationInformation.location,
      lat: locationInformation.lat,
      lng: locationInformation.lng,
    })
  }

  getAddressLocation = () => {
    return getLocation('location')
  }

  getAddressLat = () => {
    return getLocation('lat')
  }

  getAddressLng = () => {
    return getLocation('lng')
  }

  getFullLocationObject = () => {
    return Cookies.get('currentSearch')
  }

  clearLocation = () => {
    Cookies.remove('currentSearch')
    this.setState({
      location: null,
      lat: null,
      lng: null,
    })
  }
}

export default SearchContainer
